import { useLang } from "../lib/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const row = Array.from({ length: 4 });
  return (
    <section data-testid="editorial-marquee" className="relative overflow-hidden bg-[var(--ivory)] text-[var(--ink)] py-7 md:py-10 border-y border-black/10">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center" aria-hidden={k === 1}>
            {row.map((_, i) => (
              <span key={i} className="flex items-center">
                <span className="f-street uppercase text-5xl md:text-8xl px-8">{t("street")}</span>
                <span className="w-3 h-3 md:w-4 md:h-4 bg-[var(--ink)] rotate-45" />
                <span className="f-serif italic text-5xl md:text-8xl px-8 text-[var(--navy)]">{t("marquee")}</span>
                <span className="w-3 h-3 md:w-4 md:h-4 rounded-full border border-[var(--gold)]" />
                <span className="f-serif text-5xl md:text-8xl px-8">{t("oldmoney")}</span>
                <span className="f-mono text-xs px-6 tracking-[0.3em]">ANVOCRA®</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
